<template>
  <div>
    <dx-grid
      :url="url"
      name="hs-matched-students"
      :columns="columns"
      :title="title"
      ref="grid"
      :actions="actions"
      :beforeSetupGrid="beforeSetupGrid"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      :selectionEnabled="true"
      :expandedOptions="{
        enabled: true,
        template: 'hs-students-change-logs',
      }"
    ></dx-grid>

    <v-dialog v-model="updateDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update Student</v-card-title>

        <div class="px-2 mt-2">
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Child First
            </div>
            <div>{{ clickedRow.childFirst }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Child Last
            </div>
            <div>{{ clickedRow.childLast }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">Father</div>
            <div>{{ clickedRow.father }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">Address</div>
            <div>
              {{
                clickedRow.address1 +
                  " " +
                  (clickedRow.address2 ? clickedRow.address2 : "")
              }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Primary Phone
            </div>
            <div>{{ clickedRow.familyPrimaryPhone }}</div>
          </v-layout>
          <v-divider class="my-2 pb-2"></v-divider>
          <v-select
            v-if="!isVoucherDept()"
            v-model="clickedRow.hsFlag"
            label="HS Flag"
            hide-details
            class="mb-3"
            :items="hsFlagList"
            clearable
          ></v-select>
          <v-select
            v-model="clickedRow.utaFlag"
            label="UTA Flag"
            hide-details
            class="mb-3"
            :items="utaFlagList"
            clearable
          ></v-select>
          <v-text-field
            v-model="clickedRow.priority"
            label="Priority"
            type="number"
            hide-details
            class="mb-3"
          ></v-text-field>
          <v-textarea
            v-model="clickedRow.utaNote"
            label="UTA Note"
            hide-details
            class="mb-3"
            rows="5"
          ></v-textarea>
          <!-- <v-textarea
                        v-model="clickedRow.vNote"
                        label="Voucher Note"
                        hide-details
                        class="mb-3"
                        rows="5"
                    ></v-textarea> -->
        </div>
        <div v-if="matchingStudent.studentID">
          <div class="my-2 font-weight-medium text-success">
            Matched UTA Student
          </div>
          <div
            style="cursor: pointer; border-radius: 4px"
            class="pa-2 hs-selected-match"
          >
            <v-layout row justify-space-between>
              <div>
                <div
                  class="font-weight-medium caption pa-1 px-2 cyan"
                  style="color: #fff; width: fit-content;"
                >
                  {{ matchingStudent.studentID }}
                </div>
                <div class="pt-2">
                  {{
                    matchingStudent.engName + " - " + matchingStudent.hebName
                  }}
                </div>
              </div>
              <div>
                <div class="pb-2">
                  {{ matchingStudent.dob | date }}
                </div>
                <div>
                  {{ matchingStudent.branch + " - " + matchingStudent.class }}
                </div>
              </div></v-layout
            >
          </div>
        </div>
        <v-layout column justify-center>
          <div
            class="font-weight-medium title text-xs-center mt-2 text-danger"
            v-if="!matchingStudent.studentID"
          >
            No UTA Student Match
          </div>
          <v-btn
            outline
            class="text-xs-center"
            color="success"
            small
            @click="searchStudents"
            v-if="!clickedRow.utaStudentID"
            >Search Students</v-btn
          >
        </v-layout>
        <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="updateDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            v-if="matchingStudent.studentID"
            dark
            :color="clickedRow.utaStudentID ? 'warning' : 'success'"
            @click="matchStudent"
          >
            {{ clickedRow.utaStudentID ? "UNMATCH" : "MATCH" }}
          </v-btn>
          <v-btn :loading="processing" dark color="success" @click="save">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="autoMatchDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2"
          >Auto Match To UTA Student</v-card-title
        >
        <div class="px-2 my-2 font-weight-medium">
          This will match the {{ selected.length }} selected students to UTA
          students
        </div>
        <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="autoMatchDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" dark color="success" @click="autoMatch">
            Match
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="hsFlagUpdaterDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update HS Flag</v-card-title>
        <div class="px-2 mt-2">
          <div style="overflow-y: auto; height: 300px">
            <div v-for="(student, index) in selected">
              <div class="font-weight-medium">
                {{ student.childFirst + " " + student.childLast }}
              </div>
              <div class="caption">Father: {{ student.father }}</div>
              <div class="caption">
                {{
                  student.address1 +
                    " " +
                    (student.address2 ? student.address2 : "")
                }}
              </div>
              <div class="body-2">
                {{ student.familyPrimaryPhone }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < selected.length"
              ></v-divider>
            </div>
          </div>
          <v-select
            v-model="hsFlag"
            label="HS Flag"
            outline
            hide-details
            class="mb-3 mt-2"
            :items="hsFlagList"
            clearable
          ></v-select>
        </div>
        <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="hsFlagUpdaterDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" dark color="success" @click="saveHsFlag">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="utaFlagUpdaterDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update UTA Flag</v-card-title>
        <div class="px-2 mt-2">
          <div style="overflow-y: auto; height: 300px">
            <div v-for="(student, index) in selected">
              <div class="font-weight-medium">
                {{ student.childFirst + " " + student.childLast }}
              </div>
              <div class="caption">Father: {{ student.father }}</div>
              <div class="caption">
                {{
                  student.address1 +
                    " " +
                    (student.address2 ? student.address2 : "")
                }}
              </div>
              <div class="body-2">
                {{ student.familyPrimaryPhone }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < selected.length"
              ></v-divider>
            </div>
          </div>
          <v-select
            v-model="utaFlag"
            label="UTA Flag"
            outline
            hide-details
            class="mb-3 mt-2"
            :items="utaFlagList"
            clearable
          ></v-select>
        </div>
        <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="utaFlagUpdaterDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            dark
            color="success"
            @click="saveUtaFlag"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="vNoteUpdaterDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update Voucher Note</v-card-title>
        <div class="px-2 mt-2">
          <div style="overflow-y: auto; height: 300px">
            <div v-for="(student, index) in selected">
              <div class="font-weight-medium">
                {{ student.childFirst + " " + student.childLast }}
              </div>
              <div class="caption">Father: {{ student.father }}</div>
              <div class="caption">
                {{
                  student.address1 +
                    " " +
                    (student.address2 ? student.address2 : "")
                }}
              </div>
              <div class="body-2">
                {{ student.familyPrimaryPhone }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < selected.length"
              ></v-divider>
            </div>
          </div>
          <v-text-field
            v-model="vNote"
            label="Voucher Note"
            outline
            hide-details
            class="mb-3 mt-2"
          ></v-text-field>
        </div>
        <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="vNoteUpdaterDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            dark
            color="success"
            @click="saveVNoteFlag"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="priorityFlagUpdaterDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update Priority</v-card-title>
        <div class="px-2 mt-2">
          <div style="overflow-y: auto; height: 300px">
            <div v-for="(student, index) in selected">
              <div class="font-weight-medium">
                {{ student.childFirst + " " + student.childLast }}
              </div>
              <div class="caption">Father: {{ student.father }}</div>
              <div class="caption">
                {{
                  student.address1 +
                    " " +
                    (student.address2 ? student.address2 : "")
                }}
              </div>
              <div class="body-2">
                {{ student.familyPrimaryPhone }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < selected.length"
              ></v-divider>
            </div>
          </div>
          <v-text-field
            v-model="priorityFlag"
            label="Priority"
            outline
            type="number"
            hide-details
            class="mb-3 mt-2"
          ></v-text-field>
        </div>
        <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="priorityFlagUpdaterDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            dark
            color="success"
            @click="savePriorityFlag"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="searchStudentsDialog" max-width="400">
      <v-card class="pa-3">
        <div v-if="!accountStudents.length" class="my-3">
          No Students found from this family
        </div>

        <div v-if="accountStudents.length" class="mb-3">
          <div class="title pl-0 mb-2 pb-3 pt-3 text-xs-center">
            Select the student to matched to
          </div>
          <div
            v-for="student in accountStudents"
            style="cursor: pointer; border: 1px solid #eee;"
            class="pa-2 mb-2"
          >
            <v-layout
              row
              justify-space-between
              @click="onStudentSelected(student)"
            >
              <div>
                <div
                  class="font-weight-medium caption pa-1 px-2 cyan"
                  style="color: #fff; width: fit-content;"
                >
                  {{ student.studentID }}
                </div>
                <div class="pt-2">
                  {{ student.engName + " - " + student.hebName }}
                </div>
              </div>
              <div>
                <div class="pb-2">
                  {{ student.dob | date }}
                </div>
                <div>
                  {{ student.branch + " - " + student.class }}
                </div>
              </div></v-layout
            >
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="voucherStatusDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update Voucher Status</v-card-title>

        <div class="px-2 mt-2">
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">Student</div>
            <div>
              {{ clickedRow.childFirst + " " + clickedRow.childLast }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Father
            </div>
            <div>
              {{
                clickedRow.firstHebrew
                  ? clickedRow.firstHebrew + " " + clickedRow.lastHebrew
                  : ""
              }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Primary Phone
            </div>
            <div>{{ clickedRow.familyPrimaryPhone }}</div>
          </v-layout>
          <v-select
            v-model="clickedRow.voucherStatus"
            label="Voucher Status"
            class="mb-2 mt-3"
            :items="voucherStatuses.map((s) => s.status)"
            clearable
          ></v-select>
          <v-textarea
            v-model="clickedRow.voucherStatusNote"
            label="Note"
            hide-details
            class="mb-3"
            rows="3"
          ></v-textarea>
        </div>
        <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="voucherStatusDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            dark
            color="success"
            @click="saveVoucherStatus()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
  data: () => ({
    title: "HS Matched Students",

    actions: [],
    userBranch: "",
    url: "",
    regID: "",

    updateDialog: false,
    clickedRow: {},
    matchingStudent: {},
    processing: false,

    searchStudentsDialog: false,
    accountStudents: [],

    hsFlagUpdaterDialog: false,
    utaFlagUpdaterDialog: false,
    priorityFlagUpdaterDialog: false,
    autoMatchDialog: false,
    vNoteUpdaterDialog: false,
    voucherStatusDialog: false,
    totalMatched: 0,

    selected: [],
    hsFlag: "",
    utaFlag: "",
    vNote: "",
    priorityFlag: "",

    utaFlagList: [],
    hsFlagList: [],

    voucherStatuses: [],

    pagination: {
      totalCount: 0,
      rowsPerPage: 13,
      page: 1,
    },

    columns: [
      {
        label: "Screening Date",
        field: "screeningDate",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Child First",
        field: "childFirst",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Child Last",
        field: "childLast",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Birthday",
        field: "birthday",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address 1",
        field: "address1",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address 2",
        field: "address2",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Primary Phone",
        field: "familyPrimaryPhone",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father",
        field: "father",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mother",
        field: "mother",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Child Plus Family ID",
        field: "familyID",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Duplicate Student #",
        field: "childRecNum",
        type: "number",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Duplicate Students Total",
        field: "childRecCount",
        type: "number",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Source",
        field: "source",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Class 2",
        field: "utaClass2",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "UTA Flag",
        field: "utaFlag",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "HS Flag",
        field: "hsFlag",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Priority",
        field: "priority",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "UTA Note",
        field: "utaNote",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "Voucher Note",
      //     field: "vNote",
      //     format: "",
      //     visible: true,
      //     filterType: "",
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        field: "donorID",
        label: "Ansl ID",
        link: "DinnerAccountView",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Ansl Name",
        field: "anslName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Hebrew",
        field: "lastHebrew",
        format: "",
        sortOrder: "asc",
        sortIndex: 0,
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "First Hebrew",
        field: "firstHebrew",
        sortOrder: "asc",
        sortIndex: 1,
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Ansl Father",
        field: "anslFather",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Ansl Father In Law",
        field: "anslFatherInLaw",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "B",
        field: "b",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Children",
        field: "children",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "utaAccountID",
        label: "UTA Account ID",
        link: "Account View",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "VP",
        field: "vp",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "UTA Student ID",
        field: "utaStudentID",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "UTA Class",
        field: "utaClass",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "UTA Student Info",
        field: "utaStudentInfo",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "HS Note",
        field: "hsNote",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Voucher Status",
        field: "voucherStatus",
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Voucher Status Note",
        field: "voucherStatusNote",
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  async created() {
    await this.loadVoucherStatuses();

    this.columns.find((c) => c.field == "familyID").showLink = this.showLink;
    this.columns.find((c) => c.field == "donorID").showLink = this.showLink;

    this.columns.find((c) => c.field == "voucherStatus").linkAction = (row) => {
      this.openVoucherStatusDialog(row);
    };

    this.columns.find((c) => c.field == "voucherStatusNote").linkAction = (
      row
    ) => {
      this.openVoucherStatusDialog(row);
    };

    if (this.isVoucherDept()) {
      this.columns = this.columns.filter(
        (c) => !["donorID", "b", "hsFlag", "hsNote"].includes(c.field)
      );
    } else {
      // if (!this.isAdmin()) {
      //     this.columns = this.columns.filter(
      //         (c) =>
      //             !["voucherStatus", "voucherStatusNote"].includes(
      //                 c.field,
      //             ),
      //     );
      // }
    }

    this.loadUtaFlags();
    this.loadHsFlags();
  },
  beforeDestroy() {},
  methods: {
    async beforeSetupGrid() {
      this.userBranch = this.$store.state.authentication.branch;

      // this.actions.push({
      //     text: "Update HS Flag",
      //     action: this.openHsFlagUpdater,
      //     showOnSelection: true,
      // });

      this.actions.push({
        text: "Update",
        isMenu: true,
        items: [
          // {
          //     value: "update-voucher-note",
          //     text: "Update Voucher Note",
          // },
          {
            value: "update-uta-flag",
            text: "Update UTA Flag",
          },
          {
            value: "update-priority",
            text: "Update Priority",
          },
        ],
        value: "Actions",
        name: "Actions",
        action: this.openBulkUpdaterModal,
        showOnSelection: true,
      });

      this.actions.push({
        text: "Auto Match To UTA Student",
        action: this.openAutoMatchDialog,
        showOnSelection: true,
      });

      if (!this.isVoucherDept()) {
        this.actions.push({
          text: "Print Report",
          action: this.printReport,
        });
      }

      await this.loadRegID();

      const terms = await this.getTerms();

      this.actions.push({
        text: "Select Term",
        type: "select",
        values: terms,
        value: this.regID,
        onSelected: this.onTermSelected,
      });

      this.url =
        "hsStudents?onlyHs=&onlyVoucher=" +
        (this.isVoucherDept() ? "true" : "false") +
        "&regID=" +
        this.regID;
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/hsStudents/getRegID");
    },
    async getTerms() {
      return await this.$http.get("api/hsStudents/getRegTerms");
    },
    openVoucherStatusDialog(row) {
      if (!this.isVoucherDept() && !this.isAdmin()) return;

      this.clickedRow = JSON.parse(JSON.stringify(row));

      this.voucherStatusDialog = true;
    },
    onTermSelected(value) {
      this.regID = value;

      this.url =
        "hsStudents?onlyHs=&onlyVoucher=" +
        (this.isVoucherDept() ? "true" : "false") +
        "&regID=" +
        this.regID;

      this.$refs.grid.reloadDataSource(this.url);
    },
    onStudentSelected(student) {
      this.matchingStudent = {};
      this.matchingStudent = student;
      this.searchStudentsDialog = false;
    },
    async loadVoucherStatuses() {
      const statuses = await this.$http.get(
        "api/VoucherStudentStatus/GetVoucherStatuses"
      );

      this.voucherStatuses = statuses.sort((a, b) => a.sortOrder - b.sortOrder);
    },
    isVoucherDept() {
      const roles = Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];

      return roles.includes("Voucher HS");
    },
    isAdmin() {
      const isAdmin = this.$store.getters["authentication/isAdmin"];

      if (!isAdmin || isAdmin == "false") return false;

      return true;
    },
    showLink() {
      return (
        !this.$store.state.authentication.branch ||
        this.$store.state.authentication.branch == "null"
      );
    },
    openBulkUpdaterModal(option) {
      switch (option) {
        case "update-voucher-note":
          return this.openVNoteUpdater();
        case "update-uta-flag":
          return this.openUtaFlagUpdater();
        case "update-priority":
          return this.openPriorityFlagUpdater();
      }
    },
    async loadUtaFlags() {
      this.utaFlagList = (await loadOptions("UTAFlag")).map((c) => c.value);
    },
    async loadHsFlags() {
      this.hsFlagList = (await loadOptions("HSFlag")).map((c) => c.value);
    },
    async saveVoucherStatus() {
      if (!this.clickedRow.utaStudentID) {
        return this.$notify({
          text: "Can't update voucher status for unmatched student",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const today = moment().format("YYYY-MM-DD HH:mm:ss");

        await this.$http.post("api/allStudents/saveVoucherStatus", [
          {
            studentID: this.clickedRow.utaStudentID,
            status: this.clickedRow.voucherStatus,
            note: this.clickedRow.voucherStatusNote,
            okToRelease: this.clickedRow.okToRelease,
            lastUpdated: today,
            updatedBy: this.$store.state.authentication.user,
          },
        ]);

        this.processing = false;
        this.voucherStatusDialog = false;

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    openAutoMatchDialog() {
      this.selected = JSON.parse(
        JSON.stringify(this.$refs.grid.getSelectedRowsData())
      );
      this.autoMatchDialog = true;
    },
    openHsFlagUpdater() {
      this.selected = JSON.parse(
        JSON.stringify(this.$refs.grid.getSelectedRowsData())
      );
      this.hsFlagUpdaterDialog = true;
    },
    openUtaFlagUpdater() {
      this.selected = JSON.parse(
        JSON.stringify(this.$refs.grid.getSelectedRowsData())
      );
      this.utaFlagUpdaterDialog = true;
    },
    openPriorityFlagUpdater() {
      this.selected = JSON.parse(
        JSON.stringify(this.$refs.grid.getSelectedRowsData())
      );
      this.priorityFlagUpdaterDialog = true;
    },
    openVNoteUpdater() {
      this.selected = JSON.parse(
        JSON.stringify(this.$refs.grid.getSelectedRowsData())
      );
      this.vNoteUpdaterDialog = true;
    },
    async onRowClicked(row) {
      this.clickedRow = JSON.parse(JSON.stringify(row));
      this.matchingStudent = {};

      this.updateDialog = true;

      this.loadMatchingStudent();
    },
    async loadMatchingStudent() {
      this.matchingStudent = await this.$http.post(
        "api/hsStudents/GetMatchedStudents",
        this.clickedRow
      );
    },
    async searchStudents() {
      this.accountStudents = [];
      this.accountStudents = await this.$http.post(
        "api/hsStudents/GetMatchedStudentsForAccount",
        this.clickedRow
      );

      this.searchStudentsDialog = true;
    },
    async matchStudent() {
      try {
        this.processing = true;

        await this.$http.post("api/hsStudents/MatchStudent", {
          studentID: this.matchingStudent.studentID,
          id: this.clickedRow.id,
          utaAccountID: this.clickedRow.utaAccountID,
          isUnmatching: !!this.clickedRow.utaStudentID,
        });

        this.processing = false;
        this.updateDialog = false;

        this.$notify({
          text: this.clickedRow.utaStudentID
            ? "Student Unmatched"
            : "Student Matched",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async save() {
      try {
        this.processing = true;

        await this.$http.post("api/hsStudents/UpdateFlag", this.clickedRow);

        this.processing = false;
        this.updateDialog = false;

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    async autoMatch() {
      if (!this.selected.length) {
        return this.$notify({
          text: "No Students Selected",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const response = await this.$http.post(
          "api/hsStudents/AutoMatcheStudents",
          this.selected.map((s) => s.id)
        );

        this.processing = false;
        this.autoMatchDialog = false;

        this.$notify({
          text: response.total + " Students Matched",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveHsFlag() {
      if (!this.selected.length) {
        return this.$notify({
          text: "No Students Selected",
          group: "notification",
          type: "error",
        });
      }

      // if (!this.hsFlag) {
      //     return this.$notify({
      //         text: "Missing HS Flag",
      //         group: "notification",
      //         type: "error",
      //     });
      // }

      try {
        this.processing = true;

        await this.$http.post(
          "api/hsStudents/UpdateHSFlag",
          this.selected.map((s) => {
            s.hsFlag = this.hsFlag;

            return s;
          })
        );

        this.processing = false;
        this.hsFlagUpdaterDialog = false;
        this.hsFlag = "";

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveVNoteFlag() {
      if (!this.selected.length) {
        return this.$notify({
          text: "No Students Selected",
          group: "notification",
          type: "error",
        });
      }

      // if (!this.utaFlag) {
      //     return this.$notify({
      //         text: "Missing UTA Flag",
      //         group: "notification",
      //         type: "error",
      //     });
      // }

      try {
        this.processing = true;

        await this.$http.post(
          "api/hsStudents/updateVNote",
          this.selected.map((s) => {
            s.vNote = this.vNote;

            return s;
          })
        );

        this.processing = false;
        this.vNoteUpdaterDialog = false;
        this.vNote = "";

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveUtaFlag() {
      if (!this.selected.length) {
        return this.$notify({
          text: "No Students Selected",
          group: "notification",
          type: "error",
        });
      }

      // if (!this.utaFlag) {
      //     return this.$notify({
      //         text: "Missing UTA Flag",
      //         group: "notification",
      //         type: "error",
      //     });
      // }

      try {
        this.processing = true;

        await this.$http.post(
          "api/hsStudents/UpdateUtaFlag",
          this.selected.map((s) => {
            s.utaFlag = this.utaFlag;

            return s;
          })
        );

        this.processing = false;
        this.utaFlagUpdaterDialog = false;
        this.utaFlag = "";

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async savePriorityFlag() {
      if (!this.selected.length) {
        return this.$notify({
          text: "No Students Selected",
          group: "notification",
          type: "error",
        });
      }

      if (!this.priorityFlag) {
        return this.$notify({
          text: "Missing Priority Flag",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        await this.$http.post(
          "api/hsStudents/UpdatePriorityFlag",
          this.selected.map((s) => {
            s.priority = this.priorityFlag;

            return s;
          })
        );

        this.processing = false;
        this.priorityFlagUpdaterDialog = false;
        this.priorityFlag = "";

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async printReport() {
      const data = await this.$refs.grid.loadAllWithFilter();
      console.log(data);
      if (!data.length) return;

      try {
        this.processing = true;

        const response = await this.$http({
          url: "api/hsStudents/HsReport",
          method: "POST",
          data: data,
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "HS Report.pdf");
        document.body.appendChild(link);
        link.click();

        this.processing = false;
      } catch (e) {
        this.processing = false;
      }

      // var myWindow = window.open(
      //     "",
      //     "HS Report",
      //     "width=1100, height=1200",
      // );

      // myWindow.document.write(this.createClassListHtml(data));
    },
    createClassListHtml(students) {
      let html = `<head>
                        <style>
                        table {
                          font-family: arial, sans-serif;
                          border-collapse: collapse;
                          width: 100%;
                        }

                        .nice-text {
                            font-family: arial, sans-serif;
                        }

                        td, th {
                          border: 1px solid #dddddd;
                          text-align: left;
                          font-size: 12px;
                          padding: 4px;
                        }

                        tr:nth-child(even) {
                          background-color: #dddddd;
                        }

                        .right-align {
                            text-align: right;
                        }
                        .uta-note {
                            font-size: 10px !important;
                        }
                        </style>
                        </head>`;

      html += `<p class="nice-text right-align">${moment().format("LLL")}</p>`;

      html += `<h2 class="nice-text">HS Report</h2>`;

      html += `<table>
                <tr>
                <th>Child Last</th>
                <th>Child First</th>
                <th>Birthday</th>
                <th>Source</th>
                <th>HS Note</th>
                <th>VP</th>
                <th>UTA Flag</th>
                <th>UTA Note</th>
                <th class="right-align">Last Hebrew</th>
                <th class="right-align">First Hebrew</th>
                <th class="right-align">Ansl Father</th>
                <th class="right-align">Ansl Father In Law</th>
              </tr>`;

      students
        .map((student) => {
          return {
            childLast: student.childLast,
            childFirst: student.childFirst,
            birthday: moment(student.birthday).format("L"),
            source:
              student.source +
              (student.hsFlag ? student.hsFlag.replace("Apply", "") : ""),
            hsNote: student.hsNote,
            vp: student.vp ? "Y" : "",
            utaFlag: student.utaFlag,
            utaNote: student.utaNote,
            lastHebrew: student.lastHebrew,
            firstHebrew: student.firstHebrew,
            anslFather: student.anslFather,
            anslFatherInLaw: student.anslFatherInLaw,
          };
        })
        .forEach((student) => {
          html += `<tr>`;

          Object.entries(student).forEach((v) => {
            const field = v[0];
            const value = v[1];

            if (field == "utaNote") {
              html += `<td class="uta-note">${value ? value : ""}</td>`;

              return;
            }

            html += [
              "lastHebrew",
              "firstHebrew",
              "anslFather",
              "anslFatherInLaw",
            ].includes(field)
              ? `<td class="right-align">${value ? value : ""}</td>`
              : `<td>${value ? value : ""}</td>`;
          });

          html += `</tr>`;
        });

      html += `</table>`;

      return html;
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
.v-btn__content {
  color: unset;
}
.hs-selected-match {
  border: 2px solid red;
}
.hs-match {
  border: 1px solid #4caf50;
}
.students-search.container {
  padding-top: 0px;
}
</style>
